import axios from 'axios';

export const PROFILE = import.meta.env.VITE_ENV;

const service_port = import.meta.env.VITE_SERVICE_PORT;
const host_name = import.meta.env.VITE_HOSTNAME;

const protocol_http = import.meta.env.VITE_PROTOCOL;
const isLocalHost = host_name === 'localhost';
const domain = process.env.NODE_ENV === 'test' || !isLocalHost ? host_name : 'localhost:' + service_port;

function getServiceUrlSuffix() {
    switch (PROFILE) {
        case 'production':
            return '';
        case 'staging':
            return '-staging';
        default:
            return '-develop';
    }
}

const service_url_suffix = getServiceUrlSuffix();

const SSOAdresses = {
    LOCAL: {
        REDIRECT_TO: 'http://localhost:3001',
        MAIN: 'http://localhost:8080',
    },
    DEPLOYED: `https://sso${service_url_suffix}.birdseyesecurity.com`,
};

export const ALERT = `wss://alert${service_url_suffix}.birdseyesecurity.com/socket`;
export const MAIN_ADDRESS = protocol_http + domain;
export const SSO_REDIRECT_TO_ADDRESS = isLocalHost ? SSOAdresses.LOCAL.REDIRECT_TO : SSOAdresses.DEPLOYED;

export const axiosGu = axios.create({
    baseURL: MAIN_ADDRESS,
    withCredentials: true,
});

export const axiosSSO = axios.create({
    baseURL: isLocalHost ? SSOAdresses.LOCAL.MAIN : SSOAdresses.DEPLOYED,
    withCredentials: true,
});

export const configuration = {
    guForm: {
        maxFileSizeInMb: 200,
    },
};

const resolveTimeoutValue = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const refreshTokenTimeouts = {
    initial: resolveTimeoutValue(import.meta.env.VITE_REFRESH_TOKEN_TIMEOUT_INITIAL_MS, 4000),
    retry: resolveTimeoutValue(import.meta.env.VITE_REFRESH_TOKEN_TIMEOUT_RETRY_MS, 8000),
};
